import React from 'react';
import formatCurrencyToLocal from '../../../helpers/utils/formatCurrencyToLocal';
import EstimationBlock from '../templates/common/estimationBlock';

export default function template(context) {
    const calc = context.calc,
      model = calc.state.model,
      amountBtns = (
        <>
          {model.getFixAmounts().map((item, index) => {
            return (
              <button 
                className={`controllers-calculator-new__btn controllers-calculator-new__btn_${index + 1} ${+item === Number(model.getCreditSum()) ? 'active' : ''}`}
                name="creditSum" 
                key={index} 
                onClick={calc.handleChange} 
                value={item}
              >
                {(+item).toLocaleString() + ' ' + calc.l10n('UAH_ICON')}
              </button>
            )
          })}
        </>
      );

    const estimationData = [
      {
        label: calc.l10n('CALCULATOR_MONTHLY_PAYMENT_NEW'),
        value: `${model
          .getNewRequiredPayment(model.getCreditSum())
          .toLocaleString()} ${calc.l10n('UAH_ICON')}`,
      },
      {
        label: calc.l10n('CALCULATOR_CREDIT_SUM_NEW_DESIGN'),
        value: `${model.getCreditSum().toLocaleString()} ${calc.l10n('UAH_ICON')}`,
      },
      {
        label: calc.l10n('CALCULATOR_CREDIT_LOAN_TERM_LABEL_NEW_DESIGN'),
        value: calc.l10n('CALCULATOR_CREDIT_LOAN_TERM_VALUE_NEW_DESIGN'),
      },
      {
        label: calc.l10n('CALCULATOR_OVERPAYMENT'),
        value: `${formatCurrencyToLocal(
          model.getNewOverpayment(model.getCreditSum())
        )} ${calc.l10n('UAH_ICON')}`,
      },
      {
        label: calc.l10n('CALCULATOR_CREDIT_CARDS_REAL_YEAR_RATE'),
        value: `${model.getNewRealRate(model.getCreditSum())}${calc.l10n(
          'CALCULATOR_CREDIT_PERCENT'
        )}`,
      },
      {
        label: calc.l10n('CALCULATOR_TOTAL_COST'),
        value: `${formatCurrencyToLocal(
          model.getNewCreditCost(model.getCreditSum())
        )} ${calc.l10n('UAH_ICON')}`,
      },
    ];

    return (
      <>
        <div className="calculator-new__top top-calculator-new">
          <div className="top-calculator-new__body">
            <h2 className="top-calculator-new__title">{calc.l10n('CALCULATOR_NEW_TITLE')}</h2>
            <div className="top-calculator-new__base-rate">
              {calc.l10n("CALCULATOR_NEW_BASE_RATE")} <span>{model.getMonthCommission() + calc.l10n("PERCENT")}</span>
            </div>
          </div>
        </div>
        <div className="calculator-new__bottom">
          <div className="calculator-new__controllers controllers-calculator-new">
            <div className="controllers-calculator-new__title">{calc.l10n('CALCULATOR_NEW_CONTROLLERS_TITLE')}</div>
            <div className={`controllers-calculator-new__row controllers-calculator-new__row_${model.getFixAmounts().length}`}>
              {amountBtns}
            </div>
          </div>  
          <EstimationBlock
            title={calc.l10n('CALCULATOR_NEW_ESTIMATION_TITLE')}
            items={estimationData}
          />
        </div>
      </>
    );
}
